export enum FormField {
    Id = 'id',
    Note = 'note',
    IsPublic = 'isPublic',
}

export const deleteConfirmationQuestionI18nKey = 'ANALYTICS.REVIEWS.ACTIONS.DELETE_CONFIRMATION_REQUEST';
